import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { LinearProgress, CircularProgress } from '@mui/material'

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.92);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  gap: 12px;
  padding: 0 32px;
`

const BarWrapper = styled.div`
  width: 100%;
  max-width: 280px;
`

const ProgressText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1a1a2e;
  text-align: center;
  font-variant-numeric: tabular-nums;
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

const FileLoadingProgress = ({ loadingKey, totalFiles }) => {
  const progress = useSelector(state => state.files.loadingProgress?.[loadingKey])
  const loaded = progress?.loaded || 0
  const total = totalFiles || 0
  const percent = total > 0 ? Math.min((loaded / total) * 100, 100) : 0

  return (
    <Overlay>
      {total > 0 ? (
        <>
          <BarWrapper>
            <LinearProgress
              variant={loaded > 0 ? 'determinate' : 'indeterminate'}
              value={percent}
              sx={{
                height: 6,
                borderRadius: 3,
                backgroundColor: '#e0e0e0',
                '& .MuiLinearProgress-bar': {
                  borderRadius: 3,
                  backgroundColor: '#33becc'
                }
              }}
            />
          </BarWrapper>
          <ProgressText>
            {loaded > 0
              ? `Loading files: ${loaded.toLocaleString()} / ${total.toLocaleString()}`
              : `Loading ${total.toLocaleString()} files...`}
          </ProgressText>
        </>
      ) : (
        <>
          <CircularProgress size={48} style={{ color: '#33becc' }} />
          <ProgressText>Loading files...</ProgressText>
        </>
      )}
    </Overlay>
  )
}

export default FileLoadingProgress
